import React from "react";
import { steps } from "../mock";
import { ArrowRight } from "lucide-react";

const HowItWorks = () => {
  return (
    <section className="relative py-20 px-4">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-semibold tracking-[0.3em] text-sky-400 uppercase">
          Simple Process
        </p>
        <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-extrabold text-white">
          How It Works
        </h2>
        <p className="mt-4 text-slate-400">
          Get started in just 5 minutes and start receiving precision AI-powered
          trade signals directly on Telegram.
        </p>
      </div>

      <div className="relative mx-auto mt-14 max-w-3xl">
        {/* vertical line */}
        <div className="absolute left-[35px] top-4 bottom-4 w-px bg-gradient-to-b from-sky-500/60 via-blue-500/40 to-transparent" />

        <ul className="space-y-10">
          {steps.map((s) => (
            <li key={s.number} className="relative flex gap-6">
              <div className="relative z-10 flex h-[70px] w-[70px] shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-sky-500 to-blue-700 text-2xl font-black text-white shadow-[0_0_25px_rgba(59,130,246,0.5)]">
                {s.number}
              </div>
              <div className="pt-2">
                <h3 className="text-xl font-bold text-white">{s.title}</h3>
                <div className="mt-1 flex items-start gap-1 text-sky-400 font-semibold text-sm">
                  <ArrowRight className="h-4 w-4 mt-[3px] shrink-0" />
                  <span>{s.sub}</span>
                </div>
                <p className="mt-2 text-slate-400 leading-relaxed">
                  {s.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HowItWorks;
